import {getRequest,postRequest, requestAuthority } from '@/sealFilter/requestAuthority'
// 我的集卡页面的内容
let getmycardcollecting=(data)=>postRequest('/card/hechengjilu/collectionAll',data);
// 我的集卡页面的可集卡的供应商
let getcardlist=(data)=>postRequest('/card/hechengjilu/collectiontoday',data);

// 获取供应商页面是否集卡
let showconsolidationcard=(data)=>postRequest('/card/hechengjilu/currentSupplierCards',data);
// 获取供应商页面集卡成功
let cardcollectionsuccessful=(data)=>postRequest('/card/hechengjilu/collectCard',data);
// 合成接口
let getsynthesissuccessful=(data)=>postRequest('/card/hechengjilu/add',data);
export{
  getmycardcollecting,showconsolidationcard,cardcollectionsuccessful,getsynthesissuccessful,getcardlist
}


// WEBPACK FOOTER //
// ./src/api/mycardcollecting.js